/**
 * ScrollProgress Component
 * ========================
 * Fixed scroll progress indicator at the top of the page.
 */

import React from 'react';
import { useScrollProgress } from '../../hooks/useScrollProgress';

/**
 * ScrollProgress Component
 * Displays a progress bar at the top of the viewport.
 * 
 * @param {object} props - Component props
 * @param {string} [props.className] - Additional CSS classes
 * @returns {JSX.Element|null} ScrollProgress component
 */
export function ScrollProgress({ className = '' }) {
  const progress = useScrollProgress();
  
  // Don't render if at the top
  if (progress === 0) return null;
  
  return (
    <div 
      className={`fixed top-0 left-0 right-0 h-1 z-[9999] ${className}`}
      style={{ backgroundColor: 'transparent' }}
    >
      <div
        className="h-full bg-gradient-to-r from-dme-orange to-dme-orange-dark transition-all duration-75"
        style={{ 
          width: `${progress * 100}%`,
          boxShadow: '0 0 10px rgba(35, 35, 255, 0.5)',
        }}
      />
    </div>
  );
}

export default ScrollProgress;
